/**
 * 네이버·카카오 로그인 시작(인증 페이지로 이동) — 로그인 화면과 가입 중 '이미 가입된 치과' 안내가 같이 쓴다.
 * 설정(클라이언트 키)이 없으면 이동하지 않고 false 를 돌려준다(부르는 쪽이 안내를 띄운다).
 */

export const startNaverLogin = (): boolean => {
    const clientId = import.meta.env.VITE_NAVER_OAUTH_CLIENT_ID;
    if (!clientId) return false;
    const redirectUri = encodeURIComponent(
        import.meta.env.VITE_NAVER_OAUTH_CALLBACK_URL || `${window.location.origin}/login/callback/naver`
    );
    const state = crypto.randomUUID();
    sessionStorage.setItem('naver_oauth_state', state);
    window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;
    return true;
};

/** from — 로그인 뒤 돌아갈 화면(OAuth 왕복 뒤 콜백에서 소비) */
export const startKakaoLogin = (from?: string | null): boolean => {
    const clientId = import.meta.env.VITE_KAKAO_REST_API_KEY;
    if (!clientId) return false;
    const redirectUri = encodeURIComponent(
        import.meta.env.VITE_KAKAO_OAUTH_CALLBACK_URL || `${window.location.origin}/login/callback/kakao`
    );
    const state = crypto.randomUUID();
    sessionStorage.setItem('kakao_oauth_state', state);
    // OAuth 왕복 후에도 원래 보던 페이지로 복귀할 수 있도록 보존 (콜백에서 소비)
    if (from && from !== '/') {
        sessionStorage.setItem('login_return_url', from);
    } else {
        sessionStorage.removeItem('login_return_url');
    }
    // 카카오싱크: 로그인 시 채널(명치사) 추가 동의 함께 노출 → 동의 시 채널 친구 등록.
    const channelPublicId = import.meta.env.VITE_KAKAO_CHANNEL_PUBLIC_ID || '_BAjPX';
    const channelParam = channelPublicId ? `&channel_public_id=${channelPublicId}` : '';
    window.location.href = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}${channelParam}`;
    return true;
};
